// Unevo Consultant Pvt. Ltd. — content
export const UNEVO = {
  name: "Unevo Consultant",
  tagline: "Elevate Everything.",
  longTagline: "Powering Growth through Tech, Talent & Strategy.",
  intro:
    "Unevo Consultant is a global business solutions company with a strong presence in Germany, USA, and India. We specialize in software products, digital marketing, RPO, staffing, PR and brand strategy for startups and enterprises alike.",
  emails: ["info@unevoconsultant.in", "sale@unevoconsultant.in", "contact@unevoconsultant.in"],
  whatsapp: "918603834988",
  headOffice: "A-3, Calgiri Marg, Sector 1, Malviya Nagar, Jaipur, Rajasthan 302017",
};

export const UNEVO_NAV = [
  { label: "Home", href: "#home" },
  { label: "Services", href: "#services" },
  { label: "Process", href: "#process" },
  { label: "Packages", href: "#packages" },
  { label: "Global", href: "#global" },
  { label: "Contact", href: "#contact" },
];

export const SERVICES = [
  {
    id: "website",
    kicker: "01",
    icon: "layers",
    title: "Website Design & Development",
    tag: "Build",
    desc:
      "Custom, brand-tailored websites with stunning UI/UX and blistering performance. Includes 24/7 maintenance, security, and continuous optimisation.",
    bullets: ["UI/UX + Development", "Headless & CMS builds", "24/7 maintenance"],
  },
  {
    id: "software",
    kicker: "02",
    icon: "code",
    title: "Software & App Development",
    tag: "Build",
    desc:
      "From concept to launch — intuitive, high-performance Android, iOS and web platforms engineered around your business logic.",
    bullets: ["Native iOS / Android", "SaaS platforms", "Post-launch maintenance"],
  },
  {
    id: "rpo",
    kicker: "03",
    icon: "users",
    title: "Global RPO & Staffing",
    tag: "Grow",
    desc:
      "Smart, scalable Recruitment Process Outsourcing. Source, screen and place elite talent for short-term, long-term or project-based needs.",
    bullets: ["Full-cycle recruitment", "Executive search", "Contract staffing"],
  },
  {
    id: "bpo",
    kicker: "04",
    icon: "workflow",
    title: "Business Process Outsourcing",
    tag: "Operate",
    desc:
      "Customer support, tech helpdesks and back-office ops delivered by trained teams at global quality standards — with cost-per-seat that actually makes sense.",
    bullets: ["Customer support", "Tech helpdesk", "Back-office operations"],
  },
  {
    id: "pr",
    kicker: "05",
    icon: "megaphone",
    title: "PR & Reputation",
    tag: "Amplify",
    desc:
      "Strategic PR that builds trust and shapes perception — media outreach, press releases, influencer collabs and crisis management.",
    bullets: ["Press releases", "Media outreach", "Crisis management"],
  },
  {
    id: "digital",
    kicker: "06",
    icon: "trending-up",
    title: "Digital Marketing",
    tag: "Amplify",
    desc:
      "SEO, paid ads, content and email — data-backed campaigns that turn clicks into customers and traffic into pipeline.",
    bullets: ["SEO & content", "Paid ads (Google, Meta)", "Email & CRM"],
  },
  {
    id: "social",
    kicker: "07",
    icon: "share",
    title: "Social Media Marketing",
    tag: "Amplify",
    desc:
      "Instagram, LinkedIn, YouTube and beyond — scroll-stopping content, targeted campaigns and community that converts.",
    bullets: ["Content & production", "Paid social", "Community management"],
  },
];

export const PROCESS_STEPS = [
  { n: "01", title: "Concept", body: "We map your goals, audience and market — turning ideas into a concrete direction that sells." },
  { n: "02", title: "Budget", body: "Scalable proposals matched to your growth stage — no bloat, no surprises, no compromise on quality." },
  { n: "03", title: "Development", body: "Design, build and iterate with weekly demos — you see progress, not promises." },
  { n: "04", title: "Result", body: "Measurable outcomes: rankings, leads, hires or shipped software — with ongoing optimisation." },
];

export const PACKAGES = [
  {
    id: "onepage",
    tier: "Starter",
    title: "One-Page Website",
    price: "From ₹14,999",
    features: [
      "Fast, smooth-scroll single page",
      "Fully mobile-responsive",
      "Focused, high-converting CTAs",
      "Basic on-page SEO",
      "1 revision round",
    ],
  },
  {
    id: "multipage",
    tier: "Recommended",
    title: "5+ Page Website",
    price: "From ₹34,999",
    features: [
      "Structured content, dedicated pages",
      "Keyword-targeted SEO setup",
      "Professional business credibility",
      "Portfolio + testimonials sections",
      "3 revision rounds",
    ],
    highlight: true,
  },
  {
    id: "ecommerce",
    tier: "Scale",
    title: "E-commerce Store",
    price: "From ₹79,999",
    features: [
      "24/7 online storefront",
      "Secure payments & cart",
      "Inventory & order management",
      "Mobile-first checkout",
      "Built-in analytics dashboard",
    ],
  },
];

export const STATS = [
  { n: 139, suffix: "+", label: "Business Ideas Shaped" },
  { n: 165, suffix: "+", label: "Happy Customers" },
  { n: 49, suffix: "+", label: "Media Placements" },
  { n: 347, suffix: "+", label: "Projects Delivered" },
];

export const OFFICES = [
  { country: "Germany", city: "Berlin", role: "European HQ", lat: 52.52, lng: 13.4 },
  { country: "USA", city: "Rochelle Park, NJ", role: "Americas", lat: 40.9, lng: -74.08 },
  { country: "India", city: "Jaipur (Head Office)", role: "Global HQ", lat: 26.91, lng: 75.79 },
  { country: "India", city: "Noida", role: "Delivery Center", lat: 28.53, lng: 77.39 },
  { country: "India", city: "Hyderabad", role: "Engineering", lat: 17.38, lng: 78.48 },
  { country: "India", city: "Ranchi", role: "Skilling & Ops", lat: 23.34, lng: 85.31 },
];

export const LOGOS_TRUSTED = [
  "Companies1.png", "Companies2.png", "Companies3.jpg", "Companies4.jpg", "Companies5.jpg", "Companies8.png",
];
